<template>
  <div
    class="cpt-check-box wh-16 pointer rounded-[2px]"
    :class="{'is-circle': circle}"
    :style="{width: width + 'px', height: width + 'px'}"
    :disabled="disabled"
    @click="handleChangeChecked"
  >
    <template v-if="circle">
      <div class="radio wh-16" v-if="isChecked"></div>
      <div class="radio unselected wh-full" v-else></div>
    </template>
    <template v-else>
      <i class="iconfont icon-toast-success-square text-bd-tx" :style="{'font-size': width + 'px'}" v-if="isChecked"></i>
      <div class="unselected wh-full" v-else></div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ChatCheckBox',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 16
    },
    circle: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isChecked: false
    }
  },
  watch: {
    value: {
      handler (val) {
        this.isChecked = val
      },
      immediate: true
    }
  },
  methods: {
    handleChangeChecked () {
      if (this.disabled) return
      this.isChecked = !this.isChecked
      this.$emit('input', this.isChecked)
    }
  }
}
</script>

<style lang="scss">
.cpt-check-box {
  &[disabled] {
    cursor: not-allowed;
    opacity: .4;
  }
  .unselected {
    border: 2px solid $d-op-2;
    border-radius: 2px;
  }
  .radio {
    border: 2px solid $d-bd-tx;
    border-radius: 50%;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      width: 8px;
      height: 8px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: $d-bd-tx;
      border-radius: 50%;
    }
    &.unselected {
      border-color: $d-op-2;
      &::after {
        display: none;
      }
    }
  }
}
</style>